(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon/assets/javascripts/current-video-display.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon/assets/javascripts/current-video-display.js');
"use strict";


const {
  useSelector,
  useDispatch
} = ReactRedux;
const {
  VideoPlayer
} = svs.components.video_player;
const loadVideo = svs.components.video_player.contentLoader.loadVideo;
const {
  selectCurrentVideo,
  selectIsPlaying,
  selectIsReady,
  selectCurrentPosition,
  selectDuration,
  selectProgress
} = svs.components.tipsen.store.reducers.videoAnalysesSlice.selectors;
const {
  clearCurrentVideo,
  updatePlaybackState
} = svs.components.tipsen.store.reducers.videoAnalysesSlice.actions;
const CurrentVideoDisplay = () => {
  const dispatch = useDispatch();
  const currentVideo = useSelector(selectCurrentVideo);

  const isPlaying = useSelector(selectIsPlaying);
  const isReady = useSelector(selectIsReady);
  const currentPosition = useSelector(selectCurrentPosition);
  const duration = useSelector(selectDuration);
  const progress = useSelector(selectProgress);
  const [loadedVideo, setLoadedVideo] = React.useState(null);
  const [hasError, setHasError] = React.useState(false);

  const currentVideoRef = React.useRef(currentVideo);
  const pollIntervalRef = React.useRef(null);

  React.useEffect(() => {
    currentVideoRef.current = currentVideo;
  }, [currentVideo]);

  const formatTime = seconds => {
    if (typeof seconds !== 'number' || isNaN(seconds) || seconds < 0) {
      return '0:00';
    }
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return "".concat(minutes, ":").concat(remainingSeconds.toString().padStart(2, '0'));
  };

  const startPolling = React.useCallback(() => {
    if (!(loadedVideo !== null && loadedVideo !== void 0 && loadedVideo.videoId)) {
      return;
    }

    if (pollIntervalRef.current) {
      clearInterval(pollIntervalRef.current);
    }
    pollIntervalRef.current = setInterval(() => {
      if (!currentVideoRef.current) {
        clearInterval(pollIntervalRef.current);
        pollIntervalRef.current = null;
        return;
      }
      if (!svs.components.video_player) {
        return;
      }
      svs.components.video_player.isReady(loadedVideo.videoId, _ref => {
        let {
          id,
          value
        } = _ref;
        const isReady = value;
        const updateData = {
          id,
          isReady
        };
        if (isReady) {
          svs.components.video_player.getPosition(loadedVideo.videoId, position => {
            const positionValue = position === null || position === void 0 ? void 0 : position.value;
            const validPosition = typeof positionValue === 'number' && !isNaN(positionValue) && positionValue >= 0 ? positionValue : 0;
            updateData.currentPosition = validPosition;

            svs.components.video_player.getDuration(loadedVideo.videoId, dur => {
              const durationValue = dur === null || dur === void 0 ? void 0 : dur.value;
              const validDuration = typeof durationValue === 'number' && !isNaN(durationValue) && durationValue >= 0 ? durationValue : 0;
              updateData.duration = validDuration;

              svs.components.video_player.isPlaying(loadedVideo.videoId, playing => {
                const playingValue = playing === null || playing === void 0 ? void 0 : playing.value;
                const isPlayingBool = Boolean(playingValue);
                updateData.isPlaying = isPlayingBool;
                dispatch(updatePlaybackState(updateData));
              });
            });
          });
        } else {
          dispatch(updatePlaybackState(updateData));
        }
      });
    }, 1000);
  }, [loadedVideo === null || loadedVideo === void 0 ? void 0 : loadedVideo.videoId, dispatch]);
  React.useEffect(() => {
    if (!(currentVideo !== null && currentVideo !== void 0 && currentVideo.id)) {
      setLoadedVideo(null);
      setHasError(false);
      dispatch(updatePlaybackState({
        isPlaying: false,
        isReady: false,
        currentPosition: 0,
        duration: 0
      }));
      return;
    }

    setHasError(false);
    setLoadedVideo(null);
    const playerSettings = {
      type: 'solidtango',
      videoId: currentVideo.id,
      height: 480,
      width: 640,
      title: currentVideo.title || 'Video Analysis',
      api: true,
      autoplay: true
    };
    loadVideo(playerSettings, (err, model) => {
      if (err) {
        setHasError(true);
        return;
      }
      setLoadedVideo(model);
    });
  }, [currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.id, currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.title, dispatch]);


  React.useEffect(() => {
    if (!(loadedVideo !== null && loadedVideo !== void 0 && loadedVideo.videoId) || !currentVideo) {
      if (pollIntervalRef.current) {
        clearInterval(pollIntervalRef.current);
        pollIntervalRef.current = null;
      }
      return;
    }

    const startPollingTimeout = setTimeout(() => {
      startPolling();
    }, 1000);
    return () => {
      clearTimeout(startPollingTimeout);
      if (pollIntervalRef.current) {
        clearInterval(pollIntervalRef.current);
        pollIntervalRef.current = null;
      }
    };
  }, [loadedVideo === null || loadedVideo === void 0 ? void 0 : loadedVideo.videoId, currentVideo, startPolling]);
  const handleClearVideo = () => {
    dispatch(updatePlaybackState({
      isPlaying: false,
      isReady: false,
      currentPosition: 0,
      duration: 0
    }));
    dispatch(clearCurrentVideo());
  };
  if (!currentVideo) {
    return null;
  }
  return React.createElement("div", {
    className: "current-video-display"
  }, React.createElement("div", {
    className: "video-details"
  }, hasError && React.createElement("div", {
    className: "error-message"
  }, "Error loading video."), !hasError && loadedVideo && React.createElement(React.Fragment, null, React.createElement(VideoPlayer, {
    height: loadedVideo === null || loadedVideo === void 0 ? void 0 : loadedVideo.height,
    jsonLDTags: true,
    src: loadedVideo === null || loadedVideo === void 0 ? void 0 : loadedVideo.src,
    title: loadedVideo === null || loadedVideo === void 0 ? void 0 : loadedVideo.title,
    videoId: loadedVideo === null || loadedVideo === void 0 ? void 0 : loadedVideo.videoId,
    width: loadedVideo === null || loadedVideo === void 0 ? void 0 : loadedVideo.width
  }), isReady && React.createElement("div", {
    className: "video-status"
  }, React.createElement("div", {
    className: "video-status-item"
  }, React.createElement("strong", null, "Status:"), ' ', isPlaying ? 'Playing' : 'Paused'), React.createElement("div", {
    className: "video-status-item"
  }, React.createElement("strong", null, "Position:"), " ".concat(formatTime(currentPosition), " (").concat(currentPosition, "s)")), React.createElement("div", {
    className: "video-status-item"
  }, React.createElement("strong", null, "Duration:"), " ".concat(formatTime(duration), " (").concat(duration, "s)")), React.createElement("div", {
    className: "video-status-item"
  }, React.createElement("strong", null, "Progress:"), " ".concat(progress, "%"))))), loadedVideo && React.createElement("button", {
    className: "clear-video-button",
    onClick: handleClearVideo,
    type: "button"
  }, "Clear Current Video"));
};
setGlobal('svs.components.tipsen.coupon.CurrentVideoDisplay', CurrentVideoDisplay);

 })(window);